'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Toaster as Sonner } from 'sonner';
const ToastWrapper = ({ theme = 'system', toastOptions, richColors = true, ...props }) => {
    const classNames = {
        classNames: {
            title: 'text-body-3 font-medium',
            toast: 'rounded-xl shadow-large',
            description: 'text-body-4 font-normal',
        },
    };
    return _jsx(Sonner, { theme: theme, richColors: richColors, ...props, toastOptions: toastOptions ?? classNames });
};
export { ToastWrapper };
